<script setup lang="ts">
import { managerEditingIsLocked, useLegalAccountDataState } from '../../../../utilities/account/useAccountDataLegal'
import { MailIcon } from '@heroicons/vue/solid'
import { computed } from 'vue'
import AccountLegalAddManagerForm from '../AccountLegalAddManagerForm.vue'
import ManagersList from '../managers/ManagersList.vue'

const state = useLegalAccountDataState()

const managers = computed(() => {
    return state?.legalProfile?.managers
})

const pendingInvitations = computed(() => {
    return state?.legalProfile?.pending_invitations
})
</script>

<template>
    <div class="grid grid-cols-1 gap-x-4 gap-y-8 px-4 py-5 sm:px-6">
        <div class="overflow-hidden border border-gray-200 bg-white shadow sm:col-span-1 sm:rounded-md">
            <ManagersList :managers="managers"></ManagersList>
        </div>
        <div v-if="pendingInvitations.length > 0">
            <h3 class="pb-2 text-lg font-bold">
                {{ $t('legal_account_managers.pending_invitations') }}
            </h3>

            <div class="overflow-hidden border border-gray-200 bg-white shadow sm:col-span-1 sm:rounded-md">
                <ul role="list" class="ml-0 list-none divide-y divide-gray-200">
                    <li v-for="pendingInvitation in pendingInvitations" :key="pendingInvitation.email" class="mb-0">
                        <div>
                            <div class="flex items-center px-2 py-3 sm:px-4">
                                <div class="flex min-w-0 flex-1 items-center">
                                    <div class="pl flex items-center">
                                        <p class="truncate text-sm font-medium text-gray-900">
                                            {{ pendingInvitation.first_name + ' ' + pendingInvitation.last_name }}
                                        </p>
                                        <p class="ml-4 flex items-center text-sm text-gray-500">
                                            <MailIcon
                                                class="mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400"
                                                aria-hidden="true" />
                                            <span class="truncate">{{ pendingInvitation.email }}</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <div v-if="!managerEditingIsLocked()" class="border-t border-gray-200 pt-6">
            <h3 class="text-lg font-bold">
                {{ $t('legal_account_managers.add_manager') }}
            </h3>

            <AccountLegalAddManagerForm></AccountLegalAddManagerForm>
        </div>
    </div>
</template>
